module.exports = __webpack_public_path__ + "img/comstream-logo.af65b641.png";